export const environment: any = {
  production: false,
  name: 'dev',
  local: {
    domain: 'apollo-family-app',
    port: '4202'
  },
  gtm: 'GTM-NDH9T66',
};
